import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import styled from 'styled-components';
import DefaultButton from 'components/button/DefaultButton';
import { Modal, Table } from 'antd';
import Paginav from 'components/paginav/Pagination';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys, restfetcher } from 'queryClient';
import { PaymentDetailsListcolumns } from 'consts/table';
import companyInforAtom from 'atom/companyInfoAtom';
import userInforAtom from 'atom/userInfoAtom';
import { useAtomValue } from 'jotai';
import { handleDate } from 'utils/date';

interface PaymentDetailsModalProps {
  open: boolean;
  onCancel: () => void;
}

const PaymentDetailsModal = ({ onCancel, open }: PaymentDetailsModalProps) => {
  const [pageNumber, setPageNumber] = useState(0);
  const pageSize = 5;

  const userInfor = useAtomValue(userInforAtom);
  const companyInfor = useAtomValue(companyInforAtom);

  const params = {
    usridx: userInfor.usridx, //     usridx: 1608, //      companyidx: 421,
    companyidx: companyInfor.companyidx,
    page: pageNumber,
    size: pageSize
  };

  const requestPaymentDetailList = useQuery({
    queryKey: [QueryKeys.PAYMENT_DETAILS_LIST, params],
    queryFn: () =>
      restfetcher({
        method: 'POST',
        path: 'biz/my/membership/subscribe/paid',
        params: params
      })
  });

  const paymentDetailData: PaymentDetailListInfo[] =
    requestPaymentDetailList?.data?.data?.list || [];

  const totalElements = requestPaymentDetailList?.data?.data?.totalElements;
  const totalPages = requestPaymentDetailList?.data?.data?.totalPages;

  const dataSource = paymentDetailData?.map((item: PaymentDetailListInfo, index) => {
    const { cardnumber, amount, cardname, paymentdate, ticketinfo } = item;

    const outputArray = ticketinfo
      ? Object.entries(ticketinfo)
          .map(([id, data]) => {
            if (!data || typeof data !== 'object') return null;
            const ticketData = data as TicketInforType;
            return { id, ...ticketData };
          })
          .filter(Boolean)
      : [];

    return {
      key: `${index + cardnumber}`,
      date: handleDate(paymentdate),
      price: (
        <div>
          <div>{Number(amount).toLocaleString()}</div>
        </div>
      ),
      cardNumber: (
        <div>
          <div>{cardname}</div>
          <div>{cardnumber}</div>
        </div>
      ),
      paymentCount: outputArray.map((ticket) => {
        return (
          <div>
            {ticket?.ticketname}({ticket?.count})
          </div>
        );
      })
    };
  });

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };

  useEffect(() => {
    if (userInfor.usridx !== 0) {
      requestPaymentDetailList.refetch();
    }
  }, [pageNumber, userInfor.usridx]);

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={760}>
      <Wrapper>
        <Title>결제내역</Title>
        <div className="layout">
          <Table
            columns={PaymentDetailsListcolumns}
            dataSource={dataSource}
            bordered
            pagination={false}
          />
          {totalPages > 1 && (
            <PaginationWrapper>
              <Paginav
                total={totalElements}
                pageSize={pageSize}
                currentPage={pageNumber}
                onPageChange={handlePageChange}
              />
            </PaginationWrapper>
          )}
        </div>
        <DefaultButton onClick={onCancel} text="닫기" />
      </Wrapper>
    </Modal>
  );
};

export default PaymentDetailsModal;

const Title = styled.p`
  color: ${color.black2};
  text-align: center;
  ${font.h4_medium};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  p {
    display: flex;
    justify-content: center;
    button {
      width: 160px;
      border-color: ${color.gray500} !important;
      color: ${color.gray500} !important;
    }
  }

  div.layout {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .ant-table table {
    thead th,
    tbody {
      text-align: center;
    }

    thead th {
      padding: 8px 12px;
      color: ${color.gray600};
      ${font.caption1_regular};
    }

    tbody td {
      padding: 15px 12px;
      ${font.caption1_regular};
      vertical-align: middle;
    }
  }

  .ant-modal button.ant-modal-close {
    top: 16px;
    height: 16px;
  }
`;

const InforWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PayInfor = styled.div`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    ${font.body_regular};
    color: ${color.black2};
  }
`;

const Label = styled.div`
  display: flex;
  height: 32px;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 24px;
  background: ${color.red};
  color: ${color.white2};
  ${font.caption2_medium};
`;

const PaginationWrapper = styled.div`
  margin: 16px 0 32px;
  display: flex;
  justify-content: end;
`;
